import { BehaviorSubject } from 'rxjs';
import { Project } from '../../models/project.model';

export const LOAD = 'LOAD';
export const ADD = 'ADD';
export const EDIT = 'EDIT';
export const REMOVE = 'REMOVE';

export class ProjectStore {
  private projects: Project[] = [];

  items$ = new BehaviorSubject<Project[]>([]);

  dispatch(action: any) {
    this.projects = this.reduce(this.projects, action);
    this.items$.next(this.projects);
  }

  reduce(projects: Project[], action: any) {
    switch (action.type) {
      case LOAD:
        return [...action.data];
      case ADD:
        return [...projects, action.data];
      case EDIT:
        return projects.map(project => {
          const editedProject = action.data;
          if (project.uuid !== editedProject.uuid){
            return project;
          }
          return editedProject;
        });
      case REMOVE:
        return projects.filter(project => project.uuid !== action.data.uuid);
      default:
        return projects;
    }
  }
}
